import React from "react";
import { connect } from "react-redux";
import { withRouter, NavLink } from "react-router-dom";
import {
  Modalcontainer,
  HeaderContainer,
  Title,
  Message,
  Img,
  Wallet,
  Buttons,
  MoreInfo
} from "./newProjectDeniedModalStyle";
import Button from "../../../../components/button";
import Logo from "../../../../components/logo";

const NewProjectDeniedModal = props => {
  if (!props.status) {
    return null;
  } else {
    return (
      <Modalcontainer>
        <HeaderContainer>
          <Logo />
          <i
            onClick={() => props.handleShow(false)}
            className="close icon mapsa-close"
          />
        </HeaderContainer>
        <div className="body">
          <Title>ایجاد پروژه جدید</Title>
          <Message>
            سقف مجاز تعداد پروژه‌های رایگان شما به پایان رسیده است. برای ایجاد
            پروژه جدید لازم است اشتراک حرفه‌ای مپسا را خریداری کنید و یا با دعوت از
            دوستان خود برای عضویت در مپسا، امتیاز لازم را کسب کنید.
          </Message>
          <Img src="/images/premium_plan_introduction_illiu.svg" alt="مپسا" />
          <Wallet>
            <div className="label">
              <i className="icon mapsa-my-credit" />
              امتیاز‌های من
            </div>
            <div className="amount">
              {(props.data &&
                props.data.data &&
                props.data.data.user &&
                props.data.data.user.wallet.toLocaleString("fa")) ||
                (props.projects &&
                  props.projects.premium &&
                  parseInt(props.projects.premium.wallet / 10).toLocaleString("fa"))}
              <span>{"تومان"}</span>
            </div>
          </Wallet>
          <Buttons>
            <Button
              btn="primary"
              onClick={() => {
                window.location.href = "/purchase";
              }}
            >
              خرید اشتراک حرفه‌ای
            </Button>
            <Button
              btn="secondary"
              onClick={() => {
                // props.history.replace('/invitation');
                window.location.href = "/invitation";
              }}
            >
              ارسال دعوتنامه
            </Button>
          </Buttons>
          <MoreInfo>
            <NavLink to={"//mapsa.ir/pricing"} target={"_blank"}>
              اطلاعات بیشتر
            </NavLink>
          </MoreInfo>
        </div>
      </Modalcontainer>
    );
  }
};

const mapStateToProps = state => {
  return {
    data: state.Init.data || [],
    projects: state.Project
  };
};

export default withRouter(connect(mapStateToProps)(NewProjectDeniedModal));
